'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _checkboxHtml = require('./checkbox.html');

var _checkboxHtml2 = _interopRequireDefault(_checkboxHtml);

function CheckboxComponent() {
	'ngInject';

	var directive = {
		template: _checkboxHtml2['default'],
		'restrict': 'E',
		'transclude': true,
		'scope': {
			'model': '=',
			'inputName': '@inputName'
		}
	};

	return directive;
}

exports['default'] = CheckboxComponent;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/checkbox/checkbox.directive.js
 **/